import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics';
export var IsApprovedForAll = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'isApprovedForAll',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true, }),
                methodParams: {
                    owner: new FctAddress({}),
                    operator: new FctAddress({}),
                },
            },
            output: {
                isApproved: new FctBoolean({ innerIndex: 0 }),
            },
        });
    },
});
